export default {
  funds: 'Funds',
  addMoney: 'Add Money',
};
